import httpClient from "../httpClient";
import { API_USER_DEPARTMENT_LIST } from "../config";

const userDepartmentList = {
  get: (id) => httpClient.get(API_USER_DEPARTMENT_LIST + '/' + id),
};

export default userDepartmentList;
